import { StoreInfo } from './stores.types'

export const locationToSiteId = (str: string) => {
  const parts = str.split('-')
  if (parts && parts.length > 1) {
    const siteIdPart = parts[1].replace(/\D/g, '')
    return siteIdPart
  }

  return str
}

export const siteToLocationId = (stores: StoreInfo[], str?: string) => {
  if (!str) return undefined

  const parts = str.split('-')
  if (parts && parts.length === 1) {
    const store = stores.find((store) => store.inventorySiteId === str)
    if (store) {
      return store.inventoryLocationId
    }
    return str
  }

  return str
}
